/** @format */

import React, { useEffect, useState } from "react";
import axios from "axios";

const API = "https://api.lifeworthlivingfilm.com/api/v1";

const PaymentTest = () => {
  const [packages, setPackages] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");
  const [selectedPackage, setSelectedPackage] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showShipping, setShowShipping] = useState(false);

  const [shipping, setShipping] = useState({
    full_name: "",
    email: "",
    phone: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
  });

  useEffect(() => {
    getPackages();
  }, []);

  const getPackages = () => {
    setPackages([
      {
        id: 1,
        name: "72-Hour Stream Pass",
        website: "LWL",
        license_type: "stream",
        currency: "CAD",
        price: 7.99,
      },
      {
        id: 2,
        name: "Download",
        website: "LWL",
        license_type: "personal_download",
        currency: "CAD",
        price: 11.99,
      },
      {
        id: 3,
        name: "Group License",
        website: "LWL",
        license_type: "group",
        currency: "CAD",
        price: 49.99,
      },
      {
        id: 4,
        name: "DVD",
        website: "PRESCRIPTION_POISON",
        license_type: "dvd",
        currency: "USD",
        price: 24.99,
      },
      {
        id: 5,
        name: "Stream Pass",
        website: "PRESCRIPTION_POISON",
        license_type: "stream",
        currency: "USD",
        price: 9.99,
      },
    ]);
  };

  const handleShippingChange = (e) => {
    setShipping({
      ...shipping,
      [e.target.name]: e.target.value,
    });
  };

  const handlePackageChange = (e) => {
    const id = Number(e.target.value);

    setSelectedPackageId(id);

    const pkg = packages.find((p) => p.id === id);

    setSelectedPackage(pkg);

    setError("");

    if (pkg?.license_type === "dvd") {
      setShowShipping(true);
    } else {
      setShowShipping(false);

      setShipping({
        full_name: "",
        email: "",
        phone: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        country: "",
        postal_code: "",
      });
    }
  };

  const payNow = async () => {
    try {
      setLoading(true);
      setError("");

      if (!selectedPackage) {
        setError("Please select a package.");
        return;
      }

      const body = {
        package_id: selectedPackage.id,
      };

      if (selectedPackage.license_type === "dvd") {
        if (
          !shipping.full_name ||
          !shipping.email ||
          !shipping.phone ||
          !shipping.address_line_1 ||
          !shipping.city ||
          !shipping.country ||
          !shipping.postal_code
        ) {
          setError("Please fill all required shipping details.");
          return;
        }

        body.shipping_address = shipping;
      }

      const res = await axios.post(`${API}/payment/createOrder`, body);

      window.location.href = res.data.data.approveUrl;
    } catch (err) {
      console.log(err);

      setError(err?.response?.data?.message || "Unable to create payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        padding: 20,
        fontFamily: "Arial",
      }}
    >
      <h2>PayPal Payment Tester</h2>

      <p>Select any package and test the complete payment flow.</p>

      {error && (
        <div
          style={{
            background: "#ffe5e5",
            color: "#b00020",
            padding: 10,
            marginBottom: 20,
            borderRadius: 6,
          }}
        >
          {error}
        </div>
      )}

      <div style={{ marginBottom: 30 }}>
        <label>
          <strong>Select Package</strong>
        </label>

        <select
          value={selectedPackageId}
          onChange={handlePackageChange}
          style={{
            width: "100%",
            marginTop: 10,
            padding: 12,
            fontSize: 16,
          }}
        >
          <option value="">Select Package</option>

          {packages.map((pkg) => (
            <option key={pkg.id} value={pkg.id}>
              #{pkg.id} | {pkg.name} | {pkg.website} | {pkg.license_type}
            </option>
          ))}
        </select>
      </div>

      {showShipping && (
        <div
          style={{
            marginTop: 40,
            border: "1px solid #ddd",
            padding: 20,
            borderRadius: 10,
          }}
        >
          <h3>Shipping Address</h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 15,
            }}
          >
            <input
              placeholder="Full Name"
              name="full_name"
              value={shipping.full_name}
              onChange={handleShippingChange}
            />

            <input
              placeholder="Email"
              name="email"
              value={shipping.email}
              onChange={handleShippingChange}
            />

            <input
              placeholder="Phone"
              name="phone"
              value={shipping.phone}
              onChange={handleShippingChange}
            />

            <input
              placeholder="Address Line 1"
              name="address_line_1"
              value={shipping.address_line_1}
              onChange={handleShippingChange}
            />

            <input
              placeholder="Address Line 2"
              name="address_line_2"
              value={shipping.address_line_2}
              onChange={handleShippingChange}
            />

            <input
              placeholder="City"
              name="city"
              value={shipping.city}
              onChange={handleShippingChange}
            />

            <input
              placeholder="State"
              name="state"
              value={shipping.state}
              onChange={handleShippingChange}
            />

            <input
              placeholder="Country"
              name="country"
              value={shipping.country}
              onChange={handleShippingChange}
            />

            <input
              placeholder="Postal Code"
              name="postal_code"
              value={shipping.postal_code}
              onChange={handleShippingChange}
            />
          </div>
        </div>
      )}

      <div style={{ marginTop: 40 }}>
        <button
          disabled={!selectedPackage || loading}
          onClick={payNow}
          style={{
            background: "#0d6efd",
            color: "#fff",
            padding: "15px 40px",
            border: 0,
            borderRadius: 8,
            fontSize: 18,
            cursor: "pointer",
          }}
        >
          {loading ? "Creating Order..." : "Pay with PayPal"}
        </button>
      </div>
    </div>
  );
};

export default PaymentTest;
